import React from 'react';
import { article } from '../advice/styles';
import { MainLayout } from '../main-layout';
import { getModelJson } from 'features/page-model/ducks/get-model';
import { useSelector } from 'react-redux';

export const IzmeneniyaVGrafikahRabotyMagazinov = () => {
  const newModel = useSelector(getModelJson);

  const tableSizedArray = Array.from({ length: Number(newModel?.tableRowsCount) || 0 });
  const tableHeaders = newModel?.tableHeaders?.split(';') || [];

  return (
    <MainLayout>
      <div className={article}>
        <div className="container section">
          <div className="community-table section">
            <div className="community-table__table-title">{newModel?.scheduleTitle || ''}</div>
            <div className="mobile-overflov-msg">
              <div className="mobile-overflov-msg__row">
                <span className="mobile-overflov-msg__icon lm icon-swipe"></span>
                <p className="mobile-overflov-msg__text">{newModel?.tableMobileHint || ''}</p>
                <p></p>
              </div>
              <div className="mobile-overflov-msg__row">
                <span className="mobile-overflov-msg__icon lm icon-rotate"></span>
                <p className="mobile-overflov-msg__text">{newModel?.tableMobileHintSecond || ''}</p>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table community-table__table">
                <tbody>
                  <tr>
                    <th>
                      <span
                        style={{
                          color: 'rgb(91,91,91)',
                          fontWeight: 400,
                        }}>
                        {tableHeaders[0]}
                      </span>
                    </th>
                    {tableSizedArray.slice(1).map((_, headerIndex) => (
                      <th key={headerIndex}>{tableHeaders[headerIndex + 1] || ''}</th>
                    ))}
                  </tr>
                  {newModel?.tableRows?.map((tableRow, index) => {
                    const tableRowArray = tableRow.split(';');

                    return (
                      <tr key={index}>
                        {tableSizedArray.slice(0, -1).map((_, rowIndex) => (
                          <td height="20" key={rowIndex}>
                            {tableRowArray[rowIndex] || ''}
                          </td>
                        ))}
                        <td width="210"> {tableRowArray[Number(newModel?.tableRowsCount) - 1] || ''} </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
